import { writable } from "svelte/store";
export let newSupersetStore = writable<any>(null);
